import { createContext } from 'react';
import type { RenameFolderParams } from './interfaces';

type RenameFolder = {
  rename: (params: RenameFolderParams) => Promise<unknown>;
  isLoading: boolean;
};

export const RenameFolderContext = createContext<RenameFolder | null>(null);